import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Route, Redirect} from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap';
import TagManager from 'react-gtm-module';

import Can, { checkPermission } from '../../common/guards/can';
import Footer from '../../footer'
import MainPopups from './main-popups';
import BasketDropdown from '../../new-order/basket/basket-dropdown';
import UserNavigation from '../user-navigation';
import Overlay from '../overlay';

import {footerLinksForMainLayout} from '../../../data/footerLinks'
import {check as loggedIn} from '../../../utils/tokenUtils'
import CookieConsent from '../../cookie-consent/cookie-consent';

import '../../sidenav/sidenav.css'
import './main-layout.css';
import {getSystemMessage} from "../../../actions/features";

class PseudoLoginIndicator extends Component {
  componentDidMount() {
    TagManager.dataLayer({
      dataLayer: { viewMode: (this.props.active ? 'demo_mode' : 'standard_mode') }
    });
  };

  render() {
    if (!this.props.active) return null;

    return (
      <div className="pseudo-login-indicator">
        Pseudo login active
      </div>
    )
  }
}

class MainLayout extends Component {
  editContent = () => {
    this.props.dispatch({type: 'TOGGLE_EDIT_CONTENT'});
  };

  hideBasketDropdown = () => {
    this.props.dispatch({type: 'TOGGLE_BASKET_DROPDOWN'});
  };
  componentDidMount() {
    this.props.dispatch(getSystemMessage());
  }
  render() {
    const {
      component: RenderComponent,
      action,
      subjectClass,
      private: privateRoute,
      showBasketDropdown,
      dispatch,
      pageSlug,
      system_message,
      isPseudoLogin,
      ...rest
    } = this.props;

    if (privateRoute && !loggedIn()) {
      dispatch({type: 'SAVE_REQUESTED_PATH', payLoad: window.location.pathname});
    }

    const {
      showPrivacyPopup
    } = this.props.viewConfig;

    return (
      <Route {...rest} render={matchProps => privateRoute && !loggedIn() ? (
        <Redirect to='/login'/>
      ) : (
        <div className={this.props.className}>
          <Can action={action} subjectClass={subjectClass} cannot={<Redirect to="/my-profile"/>}>
              <div className='content-wrapper'>
                <UserNavigation />
                {system_message ? (
                  <div className="system-message">
                    {system_message}
                  </div>
                ) : null}
                <CookieConsent/>
                <PseudoLoginIndicator active={isPseudoLogin}/>
                {checkPermission("edit", "Page") && (
                  <a className="btn btn-grey edit-page-button" onClick={this.editContent}>
                    <Glyphicon glyph="edit"/>
                    {' '}
                    Edit page
                  </a>
                )}

                <Overlay show={showBasketDropdown} onClick={this.hideBasketDropdown}>
                  <BasketDropdown/>
                </Overlay>

                { !showPrivacyPopup && <RenderComponent pageSlug={pageSlug} {...matchProps} /> }

                <Footer links={footerLinksForMainLayout}/>
              </div>

          </Can>

          <MainPopups/>
        </div>
      )}
      />
    )
  }
}

const mapStateToProps = state => ({
  viewConfig: state.viewConfig,
  currentUser: state.currentUser.user,
  userLoading: state.currentUser.fetching,
  showBasketDropdown: state.viewConfig.showBasketDropdown,
  isPseudoLogin: state.viewConfig.profile.attributes['pseudo-login'],
  system_message: state.features.system_message
});

export default connect(mapStateToProps)(MainLayout);



// WEBPACK FOOTER //
// ./src/components/layout/main/index.jsx